import styled, { createGlobalStyle, css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const capitalizeFirstLetter = css`
    &:first-letter {
        text-transform: capitalize;
    }
`;

export const truncateLongLine = css`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const withSWReactIconFillColor = (color: string) => css`
    & ${SWReactIcons} {
        svg path,
        svg use {
            fill: ${color};
        }
    }
`;

export const StyledFadeIn = styled.div`
    animation: fade-in cubic-bezier(0.25, 0.46, 0.45, 0.94) 500ms forwards;
    opacity: 0;

    @keyframes fade-in {
        to {
            opacity: 1;
        }
    }
`;

export const StyledModalTooltipGlobal = createGlobalStyle`
    .PlainTooltip-element {
        z-index: 1121 !important; /* Overwrites ProModal z-index */
    }
`;

export const StyledParenthesisedContent = styled.span<{ color?: string }>`
    color: ${({ color }) => color ?? "inherit"};
    padding-left: 5px;

    &:before {
        content: "(";
    }

    &:after {
        content: ")";
    }
`;

export const StyledIgnoredWrapper = styled.div`
    display: contents;
`;

interface IStyledBaseDropdownButtonWrapProps {
    buttonTextColor: string;
    disabled?: boolean;
}

export const StyledBaseDropdownButtonWrap = styled.div.attrs<
    Partial<IStyledBaseDropdownButtonWrapProps>,
    IStyledBaseDropdownButtonWrapProps
>(({ buttonTextColor = colorsPalettes.carbon["200"], disabled = false }) => ({
    buttonTextColor,
    disabled,
}))`
    width: 100%;

    & .DropdownButton {
        background-color: ${colorsPalettes.carbon["0"]};
        border-color: ${colorsPalettes.midnight["50"]};
        box-sizing: border-box;
        height: 40px;

        ${({ disabled }) =>
            disabled &&
            css`
                background-color: ${colorsPalettes.bluegrey[200]};
            `}
        .DropdownButton--triangle {
            color: ${({ disabled }) => (disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon["400"])};
        }
    }

    & .DropdownButton:not(.DropdownButton--has-value) {
        color: ${(props) => props.buttonTextColor};
    }

    & .DropdownButton:active {
        background-color: ${colorsPalettes.carbon["0"]};

        .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }

    & .DropdownButton:not(.DropdownButton--has-value):active {
        color: ${(props) => props.buttonTextColor};
    }
`;
